// HistoryTimeline (Parte 14.4, REQ-AUD-006): quem fez o quê, quando, com razão/propósito. Esqueleto M0:
// recebe entradas já carregadas; o consumo de GET /{scope}/audit chega com os módulos (M4+).
import { useTranslation } from 'react-i18next';

export interface HistoryEntry {
  readonly id: string;
  readonly action: string;
  readonly actorName: string;
  readonly actorRole: string;
  /** Instante já formatado (useDateFormatter). */
  readonly occurredAt: string;
  readonly reason?: string | null;
  readonly purpose?: string | null;
  readonly summary?: string | null;
}

export interface HistoryTimelineProps {
  readonly entries: readonly HistoryEntry[];
}

export function HistoryTimeline({ entries }: HistoryTimelineProps) {
  const { t } = useTranslation('common');
  return (
    <section aria-label={t('components.history.title')} data-testid="history-timeline">
      <h2 className="mb-2 text-body font-semibold">{t('components.history.title')}</h2>
      {entries.length === 0 ? (
        <p className="text-body text-muted-foreground">{t('components.history.empty')}</p>
      ) : (
        <ol className="flex flex-col gap-3 border-l pl-4">
          {entries.map((entry) => (
            <li key={entry.id} className="text-body">
              <div className="flex flex-wrap items-baseline gap-x-2">
                <span className="font-medium">{entry.action}</span>
                <time className="text-muted-foreground">{entry.occurredAt}</time>
              </div>
              <p>
                {t('components.history.actor', { actor: entry.actorName, role: entry.actorRole })}
              </p>
              {entry.summary && <p className="text-muted-foreground">{entry.summary}</p>}
              {entry.reason && <p>{t('components.history.reason', { reason: entry.reason })}</p>}
              {entry.purpose && (
                <p>{t('components.history.purpose', { purpose: entry.purpose })}</p>
              )}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
